import { useEffect, useRef, useState } from 'react';

/**
 * Hook to reveal elements when they enter the viewport. Returns a ref to
 * attach to the element and a boolean indicating if the element is
 * visible. Once the element is visible, the observer disconnects to
 * avoid repeated triggers.
 *
 * @param {Object} options Options passed to IntersectionObserver
 */
function useReveal(options = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.1, ...options });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [options]);
  return [ref, visible];
}

export default useReveal;